// extracted by mini-css-extract-plugin
export var fileUpload = "_g7-1";
export var modalButton = "_g7-0";